/**
 * Careers JS
 * ------------------------------------------------------------------------------
 * Used in section: careers.liquid
 */

// Function to split the array based on the 'base_department' property
function splitArrayByDepartment(arr) {
  const result = {}

  arr.forEach((obj) => {
    const department = obj.department.base_department

    if (!result[department]) {
      result[department] = []
    }

    result[department].push(obj)
  })

  return Object.values(result)
}

const container = document.querySelector('#careers')

if (container != null) {
  fetch('https://api.rippling.com/platform/api/ats/v1/board/liquiddeath/jobs', {
    method: 'GET',
  })
    .then((response) => response.json())
    .then(async (jobs) => {
      const promisesToAwait = []

      jobs.forEach((job) => {
        promisesToAwait.push(
          fetch(
            `https://api.rippling.com/platform/api/ats/v1/board/liquiddeath/jobs/${job.uuid}`,
            {
              method: 'GET',
            }
          ).then((res) => res.json())
        )
      })

      const responses = await Promise.all(promisesToAwait)

      // Split the original array by the 'base_department' property
      const resultArray = splitArrayByDepartment(responses)

      resultArray.forEach((singleArray) => {
        const jobHtml = `
        <div class="accordion-job">
          <div class="accordion-job__head">
            <h3 class="accordion-job__title">
              ${singleArray[0].department.base_department}
            </h3>

            <div class="accordion-job__icon">
              <svg width='22' height='22' viewBox='0 0 33 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d="M7.16699 12L16.5003 20.6667L25.8337 12" stroke="black" stroke-width="1.5" stroke-linecap="square"/>
              </svg>
            </div>
          </div>

          <div class="accordion-job__body">
            ${singleArray
              .map((item) => {
                let description = item.description.role.trim()
                description = description.replace(/\s+/g, ' ')
                return `
                <div class="accordion-job__item">
                  <h4 class="accordion-job__item-title">
                    <a href="${item.url}">${item.name}</a>
                  </h4>

                  <div class="accordion-job__item-entry">
                    ${description}
                    <a href="${item.url}">MORE INFO</a>
                  </div>
                </div>
              `
              })
              .join('')}
          </div>
        </div>
      `

        container.insertAdjacentHTML('beforeend', jobHtml)
      })
    })
    .catch((error) => {
      console.error('Error:', error)
    })

  document.querySelector('body').addEventListener('click', function (e) {
    const _this = e.target
    if (e.target.classList.contains('accordion-job__head')) {
      _this.parentNode.classList.toggle('is-expanded')
    }
  })
}
